export const angularPageData = {
  hero: {
    heading: "Angular Web Development Company",
    subtext:
      "Quokka Labs is an Angular development company delivering maintainable web and mobile products. Our services include architecture, UI engineering, API integration, testing, performance tuning, and AngularJS migrations, helping teams ship fast, secure, scalable interfaces with clean code and predictable releases.",
    buttonText: "Talk to an Expert",
    link: "https://quokkalabs.com/contact-us",
  },

  awardsSection: {
    title: "Award-Winning Angular Development Company",
  },

  services: {
    heading: "Angular Development Services We Offer",
    intro:
      "Our Angular development services help you build, modernize, and scale reliable web and mobile interfaces. We deliver clean architecture, consistent UI components, secure integrations, and performance-focused delivery. Each service is designed to reduce bugs, improve maintainability, and support faster releases across teams, devices, and environments.",

    items: [
      {
        title: "Angular Web App Development",
        desc: "We build Angular web applications with modular architecture, reusable components, and typed API integration. Ideal for dashboards, portals, and internal tools that need stability, performance, and scalability.",
      },
      {
        title: "Angular Mobile Application Development",
        desc: "We deliver mobile-ready Angular experiences through responsive builds, PWAs, or hybrid packaging. Focus areas include fast load times, offline support where needed, and smooth navigation on phones.",
      },
      {
        title: "AngularJS Migration",
        desc: "We upgrade legacy AngularJS or older apps with phased migration plans. Our team reduces rewrite risk, maintains release stability, and validates each step with testing and controlled rollouts.",
      },
      {
        title: "Angular E-commerce Solutions",
        desc: "We build fast, conversion-focused storefronts and admin panels. Features include product catalogs, search, filters, cart and checkout flows, payment integrations, and analytics-ready tracking.",
      },
      {
        title: "Angular UI/UX Development",
        desc: "We convert product designs into accessible interfaces with reusable components and design-system alignment. Results include consistent UX, faster feature delivery, and fewer UI regressions across screens.",
      },
      {
        title: "Angular Enterprise/SaaS Solutions",
        desc: "We develop enterprise and SaaS platforms with role-based access, multi-tenant UI patterns, and scalable component systems. Angular enables predictable structure for dashboards, workflows, and complex data interactions.",
      },
      {
        title: "Angular Progressive Web App Development",
        desc: "We create PWAs that feel app-like on mobile and desktop. This includes offline support, caching strategies, push notifications where needed, and performance tuning for unstable networks.",
      },
      {
        title: "Angular Single Page Application Development",
        desc: "We build SPAs with clean routing, state management, and secure API integration. SPAs deliver smooth navigation, fast interactions, and consistent experiences for portals, dashboards, and customer apps.",
      },
      {
        title: "Angular Maintenance and Support",
        desc: "We provide ongoing maintenance, security updates, and version upgrades for applications. Our support covers bug fixes, performance monitoring, dependency management, and steady enhancements without disrupting releases.",
      },
    ],
  },

  trutStats: {
    heading:
      "Our Angular Development Company Expertise Proven by Real-world Results",
    items: [
      {
        value: "12+",
        label: "Years of Experience",
      },
      {
        value: "200+",
        label: "Projects Delivered",
      },
      {
        value: "60+",
        label: "Digital products designed and developed",
      },
      {
        value: "40%",
        label: "Faster delivery using AI engineering accelerators",
      },
    ],
  },

  mainServices: {
    heading: "Our Services",
    intro:
      "We build digital products with clear architecture, dependable performance, and automation where it improves speed and accuracy. Quokka Labs supports teams with secure applications that integrate with data systems, third-party platforms, analytics, and modern workflows - so delivery stays predictable as your product scales.",

    categories: [
      {
        title: "AI Development Services",
        items: [
          {
            title: "AI Consulting",
            desc: "We assess where AI can drive measurable value—automation, decision support, forecasting, and user experience—and define a practical plan for adoption, delivery, and long-term scalability.",
            link: "./ai-consulting-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/ai-phone.svg",
          },
          {
            title: "Generative AI Consulting",
            desc: "We identify safe, useful generative AI use cases such as knowledge search, documentation, support tooling, and reporting, then outline a pilot-to-production path with controls and clear success metrics.",
            link: "./generative-ai-consulting-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/ai-image.svg",
          },
          {
            title: "Agentic AI Development",
            desc: "We build agentic systems that handle multi-step workflows like routing, approvals, escalations, and data processing, while integrating securely with your applications, APIs, and internal tools.",
            link: "./agentic-ai-development-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/ai-programming.svg",
          },
          {
            title: "AI Native Development",
            desc: "We design products where intelligence is part of the core experience—powering workflow logic, predictions, personalization, and decision-making rather than being added as an afterthought.",
            link: "./ai-native-development-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/ai-voice.svg",
          },
          {
            title: "AI Security",
            desc: "We implement governance, monitoring, policy controls, and protected data pipelines to reduce risk in AI systems—especially for regulated environments and high-scale deployments.",
            link: "./ai-security-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/mobile-security.svg",
          },
          {
            title: "Generative AI Development",
            desc: "We deliver LLM-based solutions for insights, content generation, reporting assistants, internal chat tools, and operational support modules, with reliability checks and human review where needed.",
            link: "./generative-ai-consulting-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/ai-computer.svg",
          },
          {
            title: "AI Feature Development",
            desc: "We build AI features end-to-end—from model selection and evaluation to API integration and UI delivery—focused on accuracy, performance, and explainability for real product use.",
            link: "./ai-development-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/ai-innovation.svg",
          },
          {
            title: "ML Development",
            desc: "We develop and deploy machine learning models for forecasting, anomaly detection, optimization, and behavioral analysis, supported by reliable data pipelines and measurable performance tracking.",
            link: "./ml-development-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/ai-setting.svg",
          },
          {
            title: "AI/ML Development",
            desc: "We combine AI and ML approaches to create systems that support both real-time and batch workloads, balancing automation with transparency, reliability, and operational control.",
            link: "./artificial-intelligence-machine-learning-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/ai-brain.svg",
          },
        ],
      },

      {
        title: "App Development Services",
        items: [
          {
            title: "Mobile Application Development",
            desc: "We build secure, high-performance mobile apps that integrate with backend services to support workflows, reporting, and collaboration across devices.",
            link: "./mobile-app-development",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Frame.svg",
          },
          {
            title: "Web Application Development",
            desc: "We design and modernize web applications with modular front ends, secure APIs, and scalable architecture that can support growth in users, features, and data.",
            link: "./web-application-development",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/web-design.svg",
          },
          {
            title: "Data and Analytics",
            desc: "We turn raw data into dashboards, reporting pipelines, and actionable insights that help teams measure performance and make faster, evidence-based decisions.",
            link: "./data-analytics-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/data-recovery.svg",
          },
          {
            title: "Blockchain Development",
            desc: "We build blockchain-enabled solutions for tamper-resistant records, identity verification, audit trails, and multi-party validation where transparency and trust are required.",
            link: "./blockchain-development-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Frame2.svg",
          },
          {
            title: "iOS Application Development",
            desc: "We develop iOS apps focused on stability, performance, and secure integrations, with consistent data synchronization across services and devices.",
            link: "./ios-app-development",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Fra3.svg",
          },
          {
            title: "UI/UX Design",
            desc: "We design interfaces that prioritize clarity, usability, and accessibility—so users can complete complex tasks with fewer steps and fewer errors.",
            link: "./ui-ux-design-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Fram4.svg",
          },
          {
            title: "DevOps Services",
            desc: "We set up automation for builds and deployments, scalable infrastructure, monitoring, and incident-ready practices to support uptime and consistent releases.",
            link: "./devops-services",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/wireless-cloud.svg",
          },
          {
            title: "Quality Assurance Engineering",
            desc: "We test for reliability, integration accuracy, security gaps, and load behavior—so production releases are stable and issues are caught early.",
            link: "./quality-analyst",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/phone-check.svg",
          },
          {
            title: "AR and VR",
            desc: "We build AR/VR applications for training, simulation, visualization, and interactive experiences that improve learning, accuracy, and operational understanding.",
            link: "./ar-vr-development",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/vr-stroke-rounded.svg",
          },
        ],
      },

      {
        title: "Staff Augmentation",
        items: [
          {
            title: "Android Developers",
            desc: "Add Android engineers who build secure applications integrated with modern backend systems, APIs, and distributed infrastructure.",
            link: "./hire-android-developer",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/mobile-programming.svg",
          },
          {
            title: "iOS Developers",
            desc: "Scale delivery with iOS specialists who ship stable, well-tested apps aligned with security and quality requirements.",
            link: "./hire-ios-developer",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/appstore.svg",
          },
          {
            title: "Flutter Developers",
            desc: "Accelerate cross-platform development with Flutter engineers who maintain shared codebases without sacrificing performance or maintainability.",
            link: "./hire-flutter-developer",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/phone-developer.svg",
          },
          {
            title: "React Native Developers",
            desc: "Extend your roadmap with React Native developers who deliver consistent cross-platform experiences while reducing duplicated effort and maintenance overhead.",
            link: "./hire-react-native-developer",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/react-stroke.svg",
          },
          {
            title: "Python Developers",
            desc: "Bring in Python engineers for backend services, automation workflows, analytics platforms, and AI integrations across internal and customer-facing systems.",
            link: "./hire-python-developer",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/python.svg",
          },
          {
            title: ".NET Developers",
            desc: "Work with .NET developers to build secure, integration-ready applications with clear architecture and long-term maintainability.",
            link: "./hire-dotnet-developer",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/server-stack.svg",
          },
          {
            title: "Node.js Developers",
            desc: "Add Node.js engineers to deliver event-driven services, real-time features, and high-concurrency systems with predictable performance.",
            link: "./hire-node-js-developer",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/3rd-bracket.svg",
          },
          {
            title: "React JS Developers",
            desc: "Strengthen frontend delivery with React developers who build modular interfaces, reliable state management, and clean API-connected user experiences.",
            link: "./hire-react-js-developer",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/mobile-programming.svg",
          },
          {
            title: "Firebase Developers",
            desc: "Hire Firebase specialists to implement authentication, real-time databases, cloud storage, analytics tracking, and scalable serverless features.",
            link: "./hire-firebase-developer",
            icon: "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/fire-stroke.svg",
          },
        ],
      },
    ],
  },

  newsLetter: {
    heading:
      "Build and Scale Your Angular Product Without Rework",
    desc: "Whether you're launching a new web platform, replacing a legacy AngularJS interface, or improving performance across a growing SPA, Quokka Labs helps you ship Angular experiences that stay fast, stable, and easy to maintain. We design clean front-end architecture, integrate securely with your APIs, and support releases that don't derail your roadmap.",
    buttonText: "Get Started",
    link: "https://quokkalabs.com/contact-us",
  },

  caseStudies: {
    heading: "Angular Development Company That Turns Roadmaps into Results",

    items: [
      {
        title: "Investors Clinic",
        desc: "Investors Clinic is a single portal that helps agencies, builders, and end users list, discover, and manage property buying, selling, renting, and lead workflows—without jumping between systems.",
        results: [
          "45% faster property discovery",
          "50% quicker lead processing",
        ],
        url: "./investors-clinic",
        color: "#C5DCFF",
        image:"https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/invester-clinic.webp",
      },
    ],
  },

  keyFeatures: {
    heading: "Key Features We Integrate into Angular Applications",

    items: [
      {
        title: "Scalable Component Architecture for Large Products",
        desc: "Angular apps grow fast—until shared UI, feature teams, and release cycles start colliding. We structure codebases so features stay isolated, reusable, and easy to ship without breaking other areas.",
        points: [
          "Feature-based modules and clear ownership boundaries",
          "Reusable component libraries aligned to your design system",
          "Typed interfaces and strict linting for consistent code quality",
          "Shared utilities packaged cleanly to avoid duplication",
          "Patterns that support parallel work across multiple teams",
          "Documentation and conventions that reduce onboarding time",
        ],
      },
      {
        title: "Real-Time UI and Workflow-Driven Screens",
        desc: "For dashboards and operational tools, the UI must react instantly to changing data. We build interfaces that handle live updates, real-time states, and traceable workflows without UI lag or brittle logic.",
        points: [
          "Real-time updates via WebSockets or event streams",
          "Workflow screens for approvals, routing, and escalations",
          "Optimistic UI patterns with rollback for failed actions",
          "Live status indicators, activity feeds, and operational metrics",
          "Notifications and in-app alerts tied to user roles",
          "Error handling for partial failures and unstable networks",
        ],
      },
      {
        title: "Secure API Integrations and Role-Based Experiences",
        desc: "Angular products succeed when they connect securely with backend systems and external platforms. We build API-first front ends that manage authentication, permissions, and data access cleanly across users, roles, and tenants.",
        points: [
          "REST/GraphQL integration with typed client models",
          "SSO support (OAuth2/OIDC) with secure token handling",
          "RBAC/ABAC-ready UI permission layers",
          "API error normalization and safe retry patterns",
          "Audit-friendly UI flows with clear user actions and logs",
          "Integrations with CRM/ERP, payment gateways, and analytics tools",
        ],
      },
      {
        title: "Automation-Friendly UI for Compliance and Control",
        desc: "When the product requires traceability, approvals, or policy-driven steps, the interface can't be just screens. We build workflows that enforce rules, reduce manual steps, and support audit needs without slowing users down.",
        points: [
          "Rule-driven forms with dynamic validation and conditions",
          "Approval chains, exception handling, and escalation states",
          "Audit-ready activity trails and change histories in UI",
          "Scheduled actions and system-triggered task flows",
          "Role-based task routing and priority views",
          "Admin controls, feature flags, and configuration screens",
        ],
      },
    ],
  },

  capabilities: {
    heading: "What You Get with Our Angular Development Expertise",
    subtext:
      "Quokka Labs builds Angular products that stay easy to change, easy to test, and reliable in production. Our work is structured around the parts that impact real delivery: front-end architecture that doesn't collapse under feature growth, performance that holds up on real devices, and engineering practices that keep releases steady as teams scale.",

    items: [
      {
        title: "Product-Grade Angular Architecture",
        desc: "We design codebases with clear feature boundaries, reusable components, and predictable state patterns—so teams can ship new features without creating UI debt or breaking existing flows.",
      },
      {
        title: "Performance That Holds Under Real Usage",
        desc: "We optimize load time, rendering, and runtime behavior using bundle control, lazy loading, change detection tuning, and caching strategies—so your application stays fast as data and users grow.",
      },
      {
        title: "Secure Authentication and Permission Layers",
        desc: "We implement UI security patterns aligned with your backend—SSO/OIDC, token handling, session control, and RBAC/ABAC-ready permission logic—so the right users see the right actions and data.",
      },
      {
        title: "Integration-Ready Front Ends",
        desc: "We build Angular clients that integrate cleanly with REST/GraphQL APIs, identity providers, analytics, payments, and enterprise tools—using typed contracts and error-handling patterns that reduce integration bugs.",
      },
      {
        title: "Workflow-Driven UI That Reduces Manual Work",
        desc: "We develop interfaces that support approvals, routing, validation rules, and multi-step processes—so teams can run consistent operations without relying on spreadsheets, manual checks, or ad-hoc steps.",
      },
      {
        title: "Monitoring, Debugging, and Release Control",
        desc: "We add front-end observability and release discipline—error tracking, performance monitoring, logging standards, and CI checks—so your team can spot issues early, debug faster, and ship with confidence.",
      },
    ],
  },

  ourProcess: {
    heading:
      "Our End-to-End Delivery Process for Modern Angular Products",

    subtext:
      "A structured, engineering-led approach that turns product requirements into maintainable applications. From discovery and UI planning to front-end architecture, integration, testing, and release readiness, our process keeps delivery predictable while protecting performance, security, and long-term maintainability.",

    steps: [
      {
        number: "01",
        title: "Discovery and Angular Roadmap",
        desc: "We start by aligning on goals, users, key flows, and constraints—plus the APIs, identity systems, and tools your Angular app must connect with. Then we define feature scope, technical risks, and a delivery plan that reduces rework.",
      },
      {
        number: "02",
        title: "UI/UX Planning for Daily Use",
        desc: "We design screens around task speed and clarity, especially for multi-role products. We map navigation, page structure, and edge cases so users can complete workflows without confusion—on desktop and mobile.",
      },
      {
        number: "03",
        title: "Angular Architecture and Front-End Foundations",
        desc: "We set the foundation early: module structure, component strategy, state management, routing, and data models. We also establish security patterns, error handling, and performance guardrails so the app stays stable as it grows.",
      },
      {
        number: "04",
        title: "Iterative Development and Integration Sprints",
        desc: "We build in focused sprints and ship working increments. This includes UI components, feature modules, API integration, permissions, and workflow logic—so stakeholders can review real progress and teams can adapt quickly.",
      },
      {
        number: "05",
        title: "Testing, Performance, and Stability Hardening",
        desc: "We validate beyond 'it loads.' Coverage includes critical user journeys, role-based behavior, form validation rules, and API failure handling. We also tune bundle size, rendering performance, and runtime stability for real devices.",
      },
      {
        number: "06",
        title: "Release Readiness and Production Visibility",
        desc: "We prepare for clean deployments with CI checks, build pipelines, environment configuration, and monitoring. We add error tracking and performance telemetry so your team can detect issues early and respond fast.",
      },
      {
        number: "07",
        title: "Post-Launch Optimization and Continuous Improvement",
        desc: "After launch, we keep the product healthy—upgrading versions, reducing UI debt, improving performance, and adding features safely. As usage grows, we refine architecture so delivery stays steady.",
      },
    ],
  },

  compliance: {
    heading:
      "Built for Enterprise Compliance in Angular Applications",

    intro:
      "Compliance can't be a patch after launch—especially for customer portals, SaaS platforms, and internal tools that handle sensitive data. As an angular development company, Quokka Labs builds front ends with security, privacy, and operational controls designed in from day one. The result is an interface that supports audit readiness, protects user data, and stays dependable as regulations and scale evolve.",

    sections: [
      {
        title: "Application Security and Threat Protection",
        desc: "We reduce front-end risk with secure authentication patterns, hardened client-side logic, and automated checks across delivery. Our approach covers the most common Angular attack surfaces - identity, session handling, dependencies, and unsafe UI flows.",
      },
      {
        title: "Data Privacy and Information Governance",
        desc: "When user data is involved, the UI must enforce access boundaries and support traceability. We design applications to minimize exposure, support regional requirements, and make data handling easier to audit.",
      },
      {
        title: "Operational Resilience and Risk Controls",
        desc: "Enterprise products need consistent uptime and predictable releases. We engineer Angular delivery to reduce regressions and support faster incident response with visibility into performance and failures.",
      },
    ],

    standards: [
      "GDPR — Privacy and data protection controls",
      "CCPA — Consumer privacy requirements",
      "SOC 2 — Security and operational controls",
      "ISO/IEC 27001 — Information security management practices",
      "OWASP — Secure application best practices",
      "PCI DSS — Payment data security requirements (when payments are involved)",
    ],
  },

  industries: {
    heading:
      "Angular Solutions Built for High-Trust Industries",

    subtext:
      "Quokka Labs delivers angular development services for organizations that need secure, role-based, and high-traffic web applications. As an angular development company, we build front ends that support complex workflows, integrate with enterprise systems, and stay maintainable across long product lifecycles.",

    items: [
      {
        title: "Healthcare",
        points: [
          "Patient portals, scheduling, and care coordination dashboards",
          "EHR/EMR-ready integrations through secure APIs",
          "Role-based experiences for clinicians, staff, and admins",
          "Accessibility-focused UI and traceable user actions",
        ],
      },
      {
        title: "Manufacturing",
        points: [
          "Production monitoring dashboards and quality views",
          "Inventory, logistics, and procurement interfaces",
          "ERP-connected screens for planning and execution",
          "Real-time alerts and workflow-based approvals",
        ],
      },
      {
        title: "Education",
        points: [
          "LMS portals, student management systems, and training dashboards",
          "Secure admissions, assessment, and content delivery flows",
          "Experiences for learners, instructors, and administrators",
          "Reporting views for progress, completion, and outcomes",
        ],
      },
      {
        title: "Real Estate",
        points: [
          "Property search, filtering, and detail views optimized for speed",
          "Broker/agent portals with CRM-connected pipelines",
          "Document workflows, permissions, and status tracking",
          "Admin panels for inventory, leads, and operational reporting",
        ],
      },
      {
        title: "FinTech",
        points: [
          "Payment, lending, and account-management dashboards",
          "KYC flows, step-based verification, and audit-ready UI trails",
          "Secure sessions, permissions, and data masking patterns",
          "API-first integrations with banking and identity services",
        ],
      },
      {
        title: "Retail",
        points: [
          "Commerce admin portals, catalog tooling, and order management",
          "Inventory, returns, and fulfillment dashboards",
          "Loyalty, customer profiles, and personalization UIs",
          "Performance tuning for seasonal and campaign demand",
        ],
      },
    ],
  },

  // techStack: {
  //   heading: "Our Tech Stack",
  //   intro:
  //     "We use a modern, enterprise-ready tech stack engineered to support secure, scalable, and high-performance Angular development services.",

  //   categories: [
  //     {
  //       title: "Frontend",
  //       items: ["HTML5", "CSS3", "Tailwind CSS", "JavaScript", "Angular", "TypeScript"],
  //     },
  //     {
  //       title: "Mobile",
  //       items: ["iOS (Swift)", "Android (Kotlin)", "Flutter", "React Native", "PWA"],
  //     },
  //     {
  //       title: "Backend",
  //       items: ["Node.js", ".NET", "Python", "Java", "PHP"],
  //     },
  //     {
  //       title: "Database",
  //       items: ["MongoDB", "PostgreSQL", "MySQL", "Firebase"],
  //     },
  //     {
  //       title: "Cloud & DevOps",
  //       items: ["AWS", "Azure", "Google Cloud", "Docker", "CI/CD Pipelines"],
  //     },
  //     {
  //       title: "AI & Analytics",
  //       items: [
  //         "Machine Learning",
  //         "Generative AI",
  //         "Data Analytics",
  //         "TensorFlow",
  //       ],
  //     },
  //   ],
  // },

  newsLetter2: {
    heading:
      "Reduce Angular Maintenance Costs and Improve App Performance",

    subtext:
      "If your Angular product is getting harder to ship, slower to load, or expensive to maintain, we help you fix the foundation - not just patch symptoms. From AngularJS modernization and SPA refactoring to performance tuning and build optimization, Quokka Labs improves speed, stability, and release confidence.",

    buttonText: "Book a Call",
    link: "https://quokkalabs.com/contact-us",
  },

  ai_Focused: {
    heading: "AI-Driven Intelligence for Modern Angular Applications",

    subtext:
      "We add AI and real-time intelligence directly into experiences so users can act faster with less manual work. From in-app assistants and smart search to predictive insights and operational dashboards, we help teams turn data into clear UI decisions—without compromising security, performance, or maintainability.",

    items: [
      "AI Product Consulting for Angular Roadmaps",
      "Predictive Insights and Decision Dashboards",
      "AI-Assisted Search and Knowledge Discovery",
      "Workflow Automation and In-App Assistants",
      "Fraud, Risk, and Security Signals in the UI",
      "AI-Driven Optimization and Recommendations",
    ],
  },

  whyChoose: {
    heading:
      "Why Quokka Labs is the Angular Development Company Built for Long-Term Product Delivery",

    subtext:
      "Angular success isn't just about building screens. It takes disciplined front-end architecture, strong integration patterns, performance control, and a delivery process that stays predictable as features and teams grow. Quokka Labs works as a product engineering partner - clear communication, steady releases, and decisions that reduce rework over time.",

    items: [
      {
        number: "01",
        title: "Product-First Angular Engineering",
        desc: "We build around user flows and business outcomes, not isolated UI tickets. That means clearer requirements, fewer redesign loops, and interfaces that help users complete tasks faster.",
      },
      {
        number: "02",
        title: "Predictable Delivery with Sprint-Level Visibility",
        desc: "You get a transparent rhythm: planning, weekly progress, demos, QA sign-offs, and release checkpoints. Stakeholders can see what's shipping and why, without last-minute surprises.",
      },
      {
        number: "03",
        title: "Performance and Maintainability from Day One",
        desc: "We structure Angular apps for growth—clean modules, reusable components, stable state patterns, and performance guardrails—so the UI stays fast and the code stays readable.",
      },
      {
        number: "04",
        title: "Modernization Without Risky Rewrites",
        desc: "As an AngularJS-to-Angular capable team, we modernize legacy front ends in phases. You keep shipping while we reduce technical debt and replace fragile areas safely.",
      },
      {
        number: "05",
        title: "AI Features Only When They Improve the Product",
        desc: "We add AI where it changes outcomes—smarter search, faster support, better dashboards, reduced manual steps—not where it creates complexity without value.",
      },
      {
        number: "06",
        title: "Clear Communication and Smooth Collaboration",
        desc: "You work with a dedicated point of contact, shared sprint tools, and engineers who communicate directly. We fit into your workflow and keep decisions aligned with your roadmap.",
      },
    ],
  },

  hireCTATeamBanner: {
    heading: "Hire Top Notch Developers Around You!",

    subtext:
      "Engaging with our engineers accelerates your roadmap and strengthens compliance.",

    buttonText: "Hire Developer",
    link: "https://quokkalabs.com/contact-us",
  },

  nextGenTech: {
    heading:
      "Future-Ready Technologies That Elevate Your Angular Applications",

    subtext:
      "Our engineers build Angular products with modern capabilities that keep your front end fast, secure, and adaptable as requirements change. From cloud-delivered performance and real-time experiences to automation and intelligence, we design systems that support complex workflows, integrations, and long-term product growth without creating UI debt.",

    items: [
      {
        title: "Cloud",
        image:
          "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/cloud-new-new.webp",
        desc: "We deliver cloud-ready Angular builds optimized for reliability and speed across environments. From CDN-backed deployments to build pipelines and runtime performance tuning, we help your app load faster, scale smoothly, and stay consistent across releases.",
      },
      {
        title: "Blockchain",
        image:
          "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/block-chain-new.webp",
        desc: "When verification and traceability matter, we integrate blockchain-connected UI workflows into applications. This supports user-facing proof, transaction visibility, tamper-resistant records, and compliance-ready experiences for multi-party processes.",
      },
      {
        title: "IoT",
        image:
          "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/iot-new-new.webp",
        desc: "We connect dashboards to device and sensor data to enable real-time monitoring, asset visibility, and alert-driven operations. The result is a responsive UI that can handle live telemetry, status changes, and operational workflows across industries.",
      },
      {
        title: "Data Science & Analytics",
        image:
          "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/data-engi-new.webp",
        desc: "We build analytics-first interfaces that turn complex data into usable insights. From KPI dashboards to forecasting views and operational reporting, we help teams track performance, risk, and growth metrics with clarity and speed.",
      },
      {
        title: "Robotic Process Automation (RPA)",
        image:
          "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/robotic-new.webp",
        desc: "We integrate RPA into workflows to reduce manual steps across forms, approvals, reconciliations, and reporting. Users get faster task completion, fewer handoffs, and fewer errors—without changing how they work day to day.",
      },
      {
        title: "Generative AI",
        image:
          "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/gen-ai-new.webp",
        desc: "We embed generative AI features inside products for smarter search, guided workflows, content drafting, and internal assistants. Implementations include safety controls, governance, and UX patterns that keep outputs reliable and reviewable.",
      },
      {
        title: "Machine Learning (ML)",
        image:
          "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/ml-ne.webp",
        desc: "We surface ML-driven signals inside interfaces—predictions, recommendations, anomaly flags, and optimization prompts - so users can take action faster based on data patterns and real-time context.",
      },
      {
        title: "Agentic AI",
        image:
          "https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/agentic-ai-new.webp",
        desc: "We build agentic experiences that can guide and execute multi-step workflows across tools and systems—routing tasks, triggering actions, escalating exceptions, and reducing operational load while keeping users in control.",
      },
    ],
  },

  blogs: {
    heading: "What's New in Angular Development?",
  },

  faqs: {
    heading: "Frequently Asked Questions",

    items: [
      {
        question:
          "What does an angular development company do, and what deliverables should I expect?",
        answer:
          "An angular development company designs, builds, modernizes, and supports Angular front ends that connect to your APIs and business systems. For most projects, you should expect these deliverables:",
        points: [
          "UI architecture (feature modules, routing, state patterns, shared components)",
          "Production-ready screens (responsive, accessible, role-aware)",
          "API integration (typed models, error handling, caching where needed)",
          "Testing baseline (unit + integration; E2E for critical flows)",
          "Release setup (build pipeline, environments, monitoring hooks)",
          "Documentation (setup, conventions, handoff notes)",
        ],
      },
      {
        question:
          "What's included in angular development services for a new web app?",
        answer:
          "Most angular development services for a new app follow a predictable scope: discovery, UI build, integrations, testing, and release readiness. A solid scope usually includes:",
        points: [
          "Design-to-component implementation (design system alignment)",
          "SPA routing and guarded routes for protected screens",
          "Authentication and session handling aligned with your identity provider",
          "Forms, validation, and workflow screens (approvals, multi-step flows)",
          "Performance basics (lazy-loaded routes, image optimization, caching)",
          "Security hygiene (safe DOM usage, input handling, request protection)",
        ],
      },
      {
        question:
          "How much does it cost to hire an Angular developer or an angular app development company?",
        answer:
          "Cost is one of the most-searched questions. For an angular app development company, cost typically depends on the complexity and scope of your project. Key factors include:",
        points: [
          "App complexity (workflows, dashboards, real-time updates)",
          "Integrations (SSO, payments, CRM/ERP)",
          "Delivery mode (MVP vs. production hardening)",
          "SEO needs (SSR/hybrid rendering adds scope)",
          "Testing depth (E2E coverage for critical paths)",
        ],
      },
      {
        question:
          "How long does Angular web app development usually take?",
        answer:
          "Timelines vary, but common ranges map to three scenarios:",
        points: [
          "2–6 weeks: MVP UI, basic routing, core screens, and a small set of API integrations",
          "8–16 weeks: production-ready web app with role-based access, QA automation, and performance tuning",
          "3–6+ months: multi-tenant or enterprise systems with complex workflows, deep integrations, and advanced reporting",
          "AngularJS migrations: timelines depend on whether you modernize in phases or attempt a rewrite",
        ],
      },
      {
        question:
          "Angular vs React: which is better for my product?",
        answer:
          "Angular is often chosen for large applications where teams benefit from a structured framework, strong conventions, and TypeScript-first development—especially for complex SPAs and enterprise workflows.",
        points: [
          "Choose Angular for consistent architecture across multiple teams",
          "Choose Angular for built-in patterns for routing, forms, DI, and testing",
          "Choose Angular for a long-lived product that will undergo frequent change",
          "Choose React for a lighter framework baseline and more flexible composition choices",
        ],
      },
      {
        question:
          "Can Angular apps rank on Google, or is Angular bad for SEO?",
        answer:
          "Angular can be SEO-friendly, but it depends on rendering strategy. Pure client-side rendering can hurt SEO because crawlers have limits on how much JavaScript they execute during indexing. Common approaches include:",
        points: [
          "SSR / hybrid rendering: server renders initial HTML for better crawlability and faster first paint",
          "Pre-rendering: suitable for marketing pages with less personalization",
          "Client-side rendering only: acceptable for authenticated apps where SEO is not a goal (dashboards, portals)",
        ],
      },
      {
        question:
          "We have AngularJS - what's the safest migration plan to modern Angular?",
        answer:
          "The safest answer is usually 'phase it.' What a strong angular js development company typically does:",
        points: [
          "Audit modules, routes, and shared services",
          "Identify 'high-change' areas to migrate first for the biggest return",
          "Use an incremental strategy (hybrid where needed) instead of a big-bang rewrite",
          "Add test coverage during migration to prevent regressions",
          "Plan version upgrades with Angular's update tooling and guides",
        ],
      },
      {
        question:
          "What is angular mobile application development, and should I build a PWA?",
        answer:
          "Angular mobile application development usually means one of these approaches:",
        points: [
          "Responsive web app: fastest path; good for most mobile-friendly workflows",
          "PWA: adds installability and offline support using service workers and a web manifest",
          "Hybrid wrapper: when you need app-store distribution or deeper device integration",
          "A good team will recommend PWA when offline use, unstable networks, or repeat usage justify it",
        ],
      },
      {
        question:
          "How do you keep Angular apps fast as they scale?",
        answer:
          "Performance is a frequent pain-point as Angular apps grow. Common tactics include:",
        points: [
          "Lazy-loaded routes for large sections of the app",
          "Deferred loading for non-critical UI",
          "OnPush and smarter change-detection boundaries (when appropriate)",
          "RxJS subscription hygiene to avoid memory leaks",
          "Asset optimization (images, fonts), and bundle size control",
        ],
      },
      {
        question:
          "What security and testing practices should angular development services include?",
        answer:
          "Security and testing are among the most searched best practices topics for Angular teams. Angular emphasizes preventing XSS by keeping attacker-controlled data out of the DOM and using safe patterns for rendering and sanitization.",
        points: [
          "Unit tests for core logic and components",
          "Integration tests for critical flows",
          "End-to-end tests to validate the app like a user",
          "XSRF/CSRF handling patterns in the HTTP stack",
          "Require a clear testing strategy tied to release risk, not just a test count",
        ],
      },
    ],
  },
};